module.exports = __webpack_public_path__ + "pattern3.86f4c2397325bcd6305c.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/images/pattern3.png
// module id = ../../../../../src/assets/images/pattern3.png
// module chunks = styles